<panel width="650" [refresh]="refreshService">
	<h1>{{ 'invoice-control-list.header' | translate }}</h1>
	@if (!ordersToControl) {
		<skeletons [defaultSkeletons]="5" />
	}
	@else {
		<list-view scrollable #companyList>
			<header>{{ 'general.column.company-name' | translate }}</header>
			<header>{{ 'general.column.order-reference' | translate }}</header>
			<header defaultSort="ascending">{{ 'company.accounting-plans.start-date' | translate }}</header>
			<header>{{ 'invoice-control-list.number-of-plans' | translate }}</header>
			<header align-right>{{ 'company.accounting-plans.total-value' | translate }}</header>
			<row data-id="{{ planInfo.company.id }}" *listData="let planInfo from ordersToControl"
				 [disabled]="planInfo.remainingNumberOfPlansToControl == 0"
				 (action)="selected = planInfo"
				 [select]="selected == planInfo"
				 [brand]="planInfo.brandId"
				 [statusColor]="planInfo.startedPlanCount < planInfo.accountingPlans.length ? 'color-yellow-50' : 'color-green-50'">
				<column>{{ planInfo.company.name }}</column>
				<column>{{ planInfo.latestOrder?.referenceNumber }}</column>
				<column [sortValue]="planInfo.earliestStartDate">{{ planInfo.earliestStartDate | customDate: 'shortDate' }}</column>
				<column>{{ planInfo.startedPlanCount }}/{{ planInfo.accountingPlans.length }}</column>
				<column [sortValue]="planInfo.totalPlanValue" align-right>{{ planInfo.totalPlanValue | currency }}</column>
			</row>
		</list-view>
	}
</panel>
@if (selected) {
	<panel width="700">
		<h1>{{ selected.company.name }}</h1>
		<scrollable>
			<company-information [loading]="loadingBillingInfo" [company]="selected.company" [billingInfo]="billingInfo" />
			@if (loadingQuestionnaire) {
				<skeletons [defaultSkeletons]="5" />
			}
			@else {

				@if (hasSpecialCondition) {
					<section>
						<questionnaire [questionnaireView]="questionnaire" [showCategoryDetails]="false"></questionnaire>
					</section>
				}

				<list-view #accountingPlanList>
					@if (hasSpecialCondition) {
						<header></header>
					}
					<header>{{ 'company.product-plans.product-name' | translate }}</header>
					<header>{{ 'company.product-plans.start-date' | translate }}</header>
					<header>{{ 'company.product-plans.end-date' | translate }}</header>
					<header>{{ 'company.product-plans.interval' | translate }}</header>
					<header align-right>{{ 'company.product-plans.annual-contract-value' | translate }}</header>
					<header align-right>{{ 'company.product-plans.total-value' | translate }}</header>
					<row *listData="let plan from selected.accountingPlans"
						 (action)="selectedAccountingPlan = (selectedAccountingPlan != plan ? plan : undefined)"
						 [select]="selectedAccountingPlan == plan"
						 [highlighted]="selectedAccountingPlan == plan"
						 [disabled]="plan.startDate && plan.status != accountingPlanStatusEnum.Control"
						 [statusColor]="plan.startDate ? 'color-green-50' : 'color-yellow-50'">
						@if (hasSpecialCondition) {
							<column><icon small warning type="exclamation-triangle" title="{{ 'company.product-plans.special-condition-warning' | translate }}"></icon></column>
						}
						<column>{{ plan.productPlan | productName }}</column>
						<column>{{ plan.startDate | customDate: 'shortDate' }}</column>
						<column>{{ plan.endDate | customDate: 'shortDate' }}</column>
						<column>{{ plan.paymentInterval | paymentInterval:{ installments: plan.numberOfInstallments, accountingPlan: plan } }}</column>
						<column align-right>{{ getAnnualContractValue(plan) | currency }}</column>
						<column align-right>{{ plan.totalPlanValue | currency }}</column>
					</row>
				</list-view>
			}
		</scrollable>
		@if (selected.remainingNumberOfPlansToControl > 0) {
			<section>
				<button #confirmSingleButton confirm (click)="clearControlStatus(selectedAccountingPlan)" [active]="selectedAccountingPlan && !!selectedAccountingPlan.startDate && selectedAccountingPlan.status == accountingPlanStatusEnum.Control">{{ 'invoice-control-list.approve-selected-accounting-plan' | translate }}</button>
				<button #confirmButton confirm (click)="clearControlStatus()" [active]="selected.startedPlanCount == selected.accountingPlans.length">{{ 'invoice-control-list.approve-all-accounting-plans' | translate }}</button>
			</section>
		}
	</panel>
	@if (selectedAccountingPlan) {
		<company-products-ledger-posts [productPlans]="[selectedAccountingPlan.productPlan]" [displayProductName]="false" [accountingPlan]="selectedAccountingPlan" />
	}
}
